import React from 'react';

function TripItem(props) {
    return (
        <>
            <div className="flex my-5" >

                <div className="flex items-center">

                    <div className="w-12 h-12 flex items-center justify-center bg-sky-100 dark:bg-gray-800 rounded">
                        {props.icon}
                    </div>

                    <div className="flex flex-col">
                        <p className="text-gray-600 dark:text-gray-100 pl-3 text-xs">{props.title}</p>
                        <p className="text-gray-600 dark:text-gray-100 pl-3 text-sm">{props.description}</p>
                    </div>

                </div>


            </div>
        </>
    );
}

export default TripItem;